module.exports = __webpack_public_path__ + "media/images/flags/64/Mauritania-ac9d6864e3006fd1b755efa0df8c86e6.png";